import {ReactNode, createContext, useContext} from 'react';

interface ToastDisableContextType {
  isToastDisabled: boolean;
}

// Création du contexte avec une valeur par défaut
const ToastDisableContext = createContext<ToastDisableContextType>({
  isToastDisabled: false,
});

// Hook personnalisé pour utiliser le contexte
// eslint-disable-next-line react-refresh/only-export-components
export const useToastDisable = () => useContext(ToastDisableContext);

// Provider pour le contexte
export const ToastDisableProvider: React.FC<{
  children: ReactNode;
  disabled?: boolean; // Paramètre optionnel, par défaut à true
}> = ({children, disabled = true}) => {
  return (
    <ToastDisableContext.Provider value={{isToastDisabled: disabled}}>
      {children}
    </ToastDisableContext.Provider>
  );
};
